"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcDataTableActionsCell = void 0;
var common_constants_1 = require("../../../../common/constants/common-constants");
var bc_data_table_constants_1 = require("../bc-data-table-constants");
var BcDataTableActionsCell = (function () {
    function BcDataTableActionsCell(bcDataTableConfig) {
        this.bcDataTableConfig = bcDataTableConfig;
        this.rowActionsCb = null;
        if (bcDataTableConfig.actions && bcDataTableConfig.actions.rowAction) {
            this.rowActionsCb = bcDataTableConfig.actions.rowAction;
        }
    }
    BcDataTableActionsCell.prototype.rowsActions = function (callback) {
        this.rowActionsCb = callback;
    };
    BcDataTableActionsCell.prototype.callRowActions = function (_rows, object) {
        if (this.rowActionsCb) {
            this.rowActionsCb(_rows, object);
        }
    };
    BcDataTableActionsCell.prototype.render = function (cell) {
        var amountActions = cell.value.length;
        if (amountActions < 1) {
            return this.createEmptyActions();
        }
        else {
            return this.createIconsButtonActions(cell);
        }
    };
    BcDataTableActionsCell.prototype.createEmptyActions = function () {
        var newCell = document.createElement(common_constants_1.BcCommonConstants.TD_TAG);
        newCell.textContent = '-';
        return newCell;
    };
    BcDataTableActionsCell.prototype.createIconsButtonActions = function (cell) {
        var _this = this;
        var divContainer = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divContainer.classList.add(bc_data_table_constants_1.BcDataTableConstansts.CELL_ACTION_TYPE);
        var newCell = document.createElement(common_constants_1.BcCommonConstants.TD_TAG);
        var actions = cell.value;
        var buttons = actions.map(function (action) {
            return _this.createIconButton(action);
        });
        divContainer.append.apply(divContainer, buttons);
        newCell.appendChild(divContainer);
        return newCell;
    };
    BcDataTableActionsCell.prototype.createIconButton = function (action) {
        var iconButtonElement = document.createElement(common_constants_1.BcCommonConstants.BC_ICON_BUTTON_TAG);
        var buttonElement = this.getButton(action);
        iconButtonElement.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.CELL_ACTION_ID, action.actionId);
        iconButtonElement.appendChild(buttonElement);
        if (!action.disabled) {
            iconButtonElement.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, this.handleActionClick.bind(this));
        }
        return iconButtonElement;
    };
    BcDataTableActionsCell.prototype.getIcon = function (action) {
        var icon = document.createElement(common_constants_1.BcCommonConstants.I_TAG);
        icon.classList.add(common_constants_1.BcCommonConstants.ICONS_CLASS);
        icon.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.CELL_ACTION_ID, action.actionId);
        icon.textContent = action.icon;
        return icon;
    };
    BcDataTableActionsCell.prototype.getButton = function (action) {
        var buttonElement = document.createElement(common_constants_1.BcCommonConstants.BUTTON_TAG);
        buttonElement.classList.add(common_constants_1.BcCommonConstants.BC_ICON_BUTTON_CLASS, common_constants_1.BcCommonConstants.BC_ICON_BUTTON_MEDIUM_CLASS, common_constants_1.BcCommonConstants.BC_ICON_BUTTON_GHOST_CLASS);
        buttonElement.toggleAttribute(common_constants_1.BcCommonConstants.DISABLED, action.disabled || false);
        buttonElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, action.actionId);
        buttonElement.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.CELL_ACTION_ID, action.actionId);
        var icon = this.getIcon(action);
        buttonElement.appendChild(icon);
        return buttonElement;
    };
    BcDataTableActionsCell.prototype.findById = function (id) {
        for (var _i = 0, _a = this.bcDataTableConfig.data; _i < _a.length; _i++) {
            var subArray = _a[_i];
            var objetoId = subArray.find(function (item) { return item.type === 'id' && item.value === id; });
            if (objetoId) {
                return subArray;
            }
        }
        return null;
    };
    BcDataTableActionsCell.prototype.handleActionClick = function (event) {
        var clickedElement = event.target;
        var clickedRow = clickedElement.closest(common_constants_1.BcCommonConstants.TR_TAG);
        var clickedRowId = parseInt(clickedRow.getAttribute(bc_data_table_constants_1.BcDataTableConstansts.ROW_ID));
        var clickedObject = this.findById(clickedRowId);
        var actionId = clickedElement.getAttribute(bc_data_table_constants_1.BcDataTableConstansts.CELL_ACTION_ID);
        this.callRowActions(actionId, clickedObject);
    };
    return BcDataTableActionsCell;
}());
exports.BcDataTableActionsCell = BcDataTableActionsCell;
